import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { Toaster } from "sonner";
import { Layout } from "@/components/layout/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import ServicesOverview from "@/pages/ServicesOverview";
import ServiceDetail from "@/pages/ServiceDetail";
import Industries from "@/pages/Industries";
import AMC from "@/pages/AMC";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import CostCalculator from "@/pages/CostCalculator";
import HealthCheck from "@/pages/HealthCheck";
import LogisticsFM from "@/pages/LogisticsFM";
import IndustryLanding from "@/pages/IndustryLanding";
import AreaLanding from "@/pages/AreaLanding";
import CleaningServicesDubai from "@/pages/CleaningServicesDubai";
import Careers from "@/pages/Careers";
import QualityAndSafety from "@/pages/QualityAndSafety";
import Admin from "@/pages/Admin";
import Partners from "@/pages/Partners";

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <Toaster position="top-center" richColors closeButton />
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<ServicesOverview />} />
              <Route path="/services/:slug" element={<ServiceDetail />} />
              <Route path="/industries" element={<Industries />} />
              <Route path="/industries/logistics" element={<LogisticsFM />} />
              <Route path="/industries/:slug" element={<IndustryLanding />} />
              <Route path="/amc-sla" element={<AMC />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/cost-calculator" element={<CostCalculator />} />
              <Route path="/health-check" element={<HealthCheck />} />
              <Route path="/cleaning-services-dubai" element={<CleaningServicesDubai />} />
              <Route path="/areas/:slug" element={<AreaLanding />} />
              <Route path="/careers" element={<Careers />} />
              <Route path="/quality-and-safety" element={<QualityAndSafety />} />
              <Route path="/partners" element={<Partners />} />
            </Route>
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;
